import { Theme, ThemedStyles } from 'ui/base/theme';

import baseStyles from '../view_issue.module.css';

import fieldIconImageBrowserDaylight from '../../../assets/field_types/browser/light.png';
import fieldIconImageBrowserMidnight from '../../../assets/field_types/browser/dark.png';
import fieldIconImageAddressDaylight from '../../../assets/field_types/address/light.png';
import fieldIconImageAddressMidnight from '../../../assets/field_types/address/dark.png';
import fieldIconImageDomainDaylight from '../../../assets/field_types/domain/light.png';
import fieldIconImageDomainMidnight from '../../../assets/field_types/domain/dark.png';
import fieldIconImageFamilyDaylight from '../../../assets/field_types/family/light.png';
import fieldIconImageFamilyMidnight from '../../../assets/field_types/family/dark.png';

export type ViewIssuePartialStyles = {
  spacer: string;

  field: string;
  fieldIcon: string;
  fieldTextLeft: string;
  fieldTextRight: string;
  fieldInfo: string;
  fieldInfoLong: string;

  item: string;

  modalContainer: string;
  modalContainerPopOut: string;
  modalHeaderRow: string;
  modalContentRow: string;
  modalCloseIcon: string;

  cardDefault: string;
  cardSelected: string;
  cardIcon: string;
  cardText: string;
  cardInfo: string;

  clickable: string;
  disabled: string;

  open: string;
};

export const viewIssuePartialThemedStyles: ThemedStyles<ViewIssuePartialStyles> = {
  [Theme.DAYLIGHT]: {
    spacer: baseStyles.spacer,

    field: baseStyles.field,
    fieldIcon: baseStyles.fieldIcon,
    fieldTextLeft: baseStyles.fieldTextLeft,
    fieldTextRight: baseStyles.fieldTextRight,
    fieldInfo: baseStyles.fieldInfo,
    fieldInfoLong: baseStyles.fieldInfoLong,

    item: baseStyles.daylightItem,

    modalContainer: baseStyles.modalContainer,
    modalContainerPopOut: baseStyles.modalContainerPopOut,
    modalHeaderRow: baseStyles.modalHeaderRow,
    modalContentRow: baseStyles.modalContentRow,
    modalCloseIcon: baseStyles.daylightModalCloseIcon,

    cardDefault: baseStyles.daylightCardDefault,
    cardSelected: baseStyles.daylightCardSelected,
    cardIcon: baseStyles.cardIcon,
    cardText: baseStyles.cardText,
    cardInfo: baseStyles.cardInfo,

    clickable: baseStyles.clickable,
    disabled: baseStyles.disabled,

    open: baseStyles.daylightOpen,
  },
  [Theme.MIDNIGHT]: {
    spacer: baseStyles.spacer,

    field: baseStyles.field,
    fieldIcon: baseStyles.fieldIcon,
    fieldTextLeft: baseStyles.fieldTextLeft,
    fieldTextRight: baseStyles.fieldTextRight,
    fieldInfo: baseStyles.fieldInfo,
    fieldInfoLong: baseStyles.fieldInfoLong,

    item: baseStyles.midnightItem,

    modalContainer: baseStyles.modalContainer,
    modalContainerPopOut: baseStyles.modalContainerPopOut,
    modalHeaderRow: baseStyles.modalHeaderRow,
    modalContentRow: baseStyles.modalContentRow,
    modalCloseIcon: baseStyles.midnightModalCloseIcon,

    cardDefault: baseStyles.midnightCardDefault,
    cardSelected: baseStyles.midnightCardSelected,
    cardIcon: baseStyles.cardIcon,
    cardText: baseStyles.cardText,
    cardInfo: baseStyles.cardInfo,

    clickable: baseStyles.clickable,
    disabled: baseStyles.disabled,

    open: baseStyles.midnightOpen,
  },
};

export type ViewIssueFieldIconPartialStyles = {
  browser: string;
  address: string;
  domain: string;
  family: string;
};

export const themedFieldIconImageStyles: ThemedStyles<ViewIssueFieldIconPartialStyles> = {
  [Theme.DAYLIGHT]: {
    browser: fieldIconImageBrowserDaylight,
    address: fieldIconImageAddressDaylight,
    domain: fieldIconImageDomainDaylight,
    family: fieldIconImageFamilyDaylight,
  },
  [Theme.MIDNIGHT]: {
    browser: fieldIconImageBrowserMidnight,
    address: fieldIconImageAddressMidnight,
    domain: fieldIconImageDomainMidnight,
    family: fieldIconImageFamilyMidnight,
  },
};
